var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationsFunnelTrafficChatBot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    x: -0.059,
    y: -0.059,
    fill: "#19E699",
    rx: 32
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5 13.5c.828 0 1.5.672 1.5 1.5v16.5c0 .828-.672 1.5-1.5 1.5H21l-6 4.5V33h-1.5c-.828 0-1.5-.672-1.5-1.5V15c0-.828.672-1.5 1.5-1.5h21zm0 1.5h-21v16.5H15c.77 0 1.403.58 1.49 1.325l.01.175v1.5l3.6-2.7c.208-.156.451-.254.707-.287L21 31.5h13.5V15zm-16.11 9.86c2.196 1.334 4.086 2.043 5.657 2.141 1.62.102 3.542-.138 5.761-.726.4-.106.811.133.917.533.106.4-.133.811-.533.917-2.364.626-4.443.886-6.239.774-1.846-.116-3.956-.907-6.343-2.358-.354-.215-.466-.677-.25-1.03.214-.355.676-.467 1.03-.252zM28.5 19.5c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5S27 21.828 27 21s.672-1.5 1.5-1.5zm-7.5 0c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5z",
    transform: "translate(8 8)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationsFunnelTrafficChatBot);
export default __webpack_public_path__ + "static/media/illustrations-funnel-traffic-chat-bot.68b58a20.svg";
export { ForwardRef as ReactComponent };